function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// mui imports
import MuiInputLabel from "@mui/material/InputLabel";
// @limitless
import Typography from "../../data-display/typography/Typography";
import { useTranslation } from "@limitless/common/hooks";
const InputLabel = ({
  label = "",
  required = false,
  id,
  disabled = false,
  ...rest
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(MuiInputLabel, _extends({
    htmlFor: id,
    id: `${id}-label`,
    disabled: disabled
  }, rest), t(label), required && /*#__PURE__*/React.createElement(Typography, {
    sx: {
      color: theme => theme.palette.error.main,
      marginLeft: 0.5
    },
    variant: "caption"
  }, "*"));
};
InputLabel.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool
};
export default InputLabel;